import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const VotingManagementPreviewForm = ({
  enableGlobalLoader,
  disableGlobalLoader,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [voting, setVoting] = useState();
  const [formReady, setFormReady] = useState(false);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [votesHistory, setVotesHistory] = useState([]);
  const [statusChanges, setStatusChanges] = useState([]);

  let pageTitle = "Szczegóły głosowania";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getVotingPreviewDetails.path, entryId, true)
      .then((data) => {
        setVoting(data);
        apiGetByIdRequest(apiEndpoints.getVotesHistory.path, entryId, true)
          .then((data) => {
            disableGlobalLoader();
            setVotesHistory(data);

            apiGetByIdRequest(
              apiEndpoints.getVotingStatusChanges.path,
              entryId,
              true
            )
              .then((data) => {
                disableGlobalLoader();
                setStatusChanges(data);
                setFormReady(true);
              })
              .catch((error) => {
                disableGlobalLoader();
              });
          })
          .catch((error) => {
            disableGlobalLoader();
          });
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, [reloadCounter]);

  const cancelVoteHandler = (canceledVote) => {
    enableGlobalLoader();

    if (canceledVote) {
      apiPutRequest(
        apiEndpoints.cancelVote.path,
        {
          id: canceledVote.id,
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          setReloadCounter(reloadCounter + 1);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
    }
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form
            formReady={formReady}
            voting={voting}
            votesHistory={votesHistory}
            statusChanges={statusChanges}
            onCancelVote={cancelVoteHandler}
          />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(VotingManagementPreviewForm);
